import { render } from "./ClientRequests.vue?vue&type=template&id=5e9a8932&scoped=true"
import script from "./ClientRequests.vue?vue&type=script&lang=js"
export * from "./ClientRequests.vue?vue&type=script&lang=js"

import "./ClientRequests.vue?vue&type=style&index=0&id=5e9a8932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9a8932"]])

export default __exports__